/**
 * Aplica acréscimos no valor do produto Mensalidade, por estado, alterando o valor do produto passado por parâmetro
 * Prioriza a aplicação de acréscimos por estado acima dos acréscimos gerais
 * @param {Object} produto produto que será analisado
 * @param {String} estado sigla do estado
 */
function aplicaAcrescimoMensalidade(produto, estado) {
  const produtoObj = { ...produto };
  const { acrescimoMensalidade } = produtoObj;

  let objAcrescimoMensalidade = acrescimoMensalidade;
  if (typeof acrescimoMensalidade === 'string') {
    objAcrescimoMensalidade = JSON.parse(acrescimoMensalidade);
  }

  const configPorEstado = objAcrescimoMensalidade.find((config) =>
    config.uf.includes(estado),
  );

  if (configPorEstado) {
    const porcentoAcrescimoMensalidadeDefinido = parseFloat(
      configPorEstado.valor,
    );
    produtoObj.valor =
      produtoObj.valor +
      produtoObj.valor * (porcentoAcrescimoMensalidadeDefinido / 100);
    return produtoObj;
  }

  const configGeral = objAcrescimoMensalidade.find(
    (config) => config.uf.length === 0,
  );

  if (configGeral) {
    const porcentoAcrescimoMensalidadeDefinido = parseFloat(configGeral.valor);
    produtoObj.valor =
      produtoObj.valor +
      produtoObj.valor * (porcentoAcrescimoMensalidadeDefinido / 100);
    return produtoObj;
  }

  return produtoObj;
}

export default { aplicaAcrescimoMensalidade };
